//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const StateFormDefVisibilityTypo: FeatureFlag = {"Id":"StateFormDefVisibilityTypo","Label":"(KILL)[10.27]StateFormDefVisibilityTypo","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Fix visibility logic typo for state forms. Only has an effect while NewStateFormDefVisibility is off, and is removed along with it.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
